export interface IsAlive {
  status: IsAliveStatus;
}

export enum IsAliveStatus {
  Available = "Available",
  Error = "Error",
}
